import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserpilotReloader } from '../../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'popup-processing',
  templateUrl: './processing-popup.component.html',
  styleUrls: ['./processing-popup.component.scss']
})
export class ProcessingPopupComponent extends UserpilotReloader implements OnInit {

  @Output() popupCloseEvent = new EventEmitter<any>();

  constructor() {
    super();
  }

  ngOnInit() {
  }

  popupCancel() {
      this.popupCloseEvent.emit(null);
  }

  onSubmit() {
      this.popupCloseEvent.emit(null);
  }

}
